module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2014-11-17.b7fb36bf.md";